import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/6f525a4a-cdb0-467b-bab1-be67d70d3a04";
export const REGISTER_URL = "https://a.ntrk2.com/b0229fc1-ddd1-4a33-a1e0-edc6164ed504";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://ezcashbd.kzw2a.com/download?openExternalBrowser=1&id=fehoyvtt7ud0ong";

export * from "./codes";
export * from "./context";
